import React from 'react';
import PropTypes from 'prop-types'
import { useFormContext, useController } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { Radio } from "./index";

const RadioGroup = ({ options, name, handleChange }) => {
  const { control } = useFormContext()
  const {
    field: { value, onChange, ref, ...inputProps },
    formState: { errors }
  } = useController({ name, control })


  const onChangeExtend = newValue => {
    onChange(newValue)
    handleChange(name, newValue)
  }

  return (
    <>
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => (
          <small className="text-danger">
            {message}
          </small>
        )}
      />
      {options.map(option => {
        return (
          <div key={option.value}>
            <Radio
              disabled={option.disabled}
              value={option.value}
              label={option.label}
              onChange={onChangeExtend}
              checked={option.value === value}
              inputRef={ref}
              {...inputProps}
            />
          </div>
        );
      })}
    </>
  )
}

RadioGroup.defaultProps = {
  handleChange: () => {},
}

RadioGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
  })),
}

export default RadioGroup


